<script>
import { simpleComputed } from '@state/helpers'

export default {
	components: {},
	props: {

	},
	data() {
		return {
		}
	},
	computed : {
		...simpleComputed,
	},
	mounted() {
	},
	methods : {
	},

}
</script>

<template>
	<div className="justify-content-center" style="position: fixed; top: 10px; left:5%; right:5%; z-index:999999; width:90%; text-align:center">
		<!-- <b-alert v-for="(v) in messages" :key="v.time" show :variant="v.type">{{v.msg}}</b-alert> -->
		<C.DismissAlert v-for="(v) in messages" :key="v.time" :time="v.time" :variant="v.type">
			{{v.msg}}
		</C.DismissAlert>
	</div>
</template>
